var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"options":_vm.Options,"chartData":_vm.Data}})}
var staticRenderFns = []

export { render, staticRenderFns }